import {Environment} from '../app/core/types/environment.types';

export const environment: Environment = {
  production: true,
  hostname: 'https://crm-easyclean.ru',
  port: '',
  stage: 'Prod'
};
